import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { NgSelectModule } from '@ng-select/ng-select';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { CookieService } from 'ngx-cookie-service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { provideNgxWebstorage, withNgxWebstorageConfig, withLocalStorage, withSessionStorage } from 'ngx-webstorage';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorIntercept } from './interceptors/error.interceptor';
import { HttpRequestInterceptor } from './interceptors/http-request.interceptor';
import { AutocompleteComponent } from './layout/autocomplete/autocomplete.component';
import { AdminComponent } from './MainPage/admin/admin.component';
import { CheckoutComponent } from './MainPage/checkout/checkout.component';
import { FooterComponent } from './MainPage/footer/footer.component';
import { HeaderComponent } from './MainPage/header/header.component';
import { MainComponent } from './MainPage/main/main.component';
import { DynamicContentComponent } from './MainPage/navigation/dynamic-content/dynamic-content.component';
import { NavigationComponent } from './MainPage/navigation/navigation.component';
import { PanelsComponent } from './MainPage/navigation/panels/panels.component';
import { TestCentersComponent } from './MainPage/navigation/test-centers/test-centers.component';
import { TestsComponent } from './MainPage/navigation/tests/tests.component';
import { ModalModule } from './Modals/modal.module';
import { DynamicRouterPipe } from './pipes/dynamic-router.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { TestFormatPipe } from './pipes/test-Format';
import { DataService } from './services/data.service';
import { MaterialModule } from './shared/material-module';
import { TestListComponent } from './Tests/test-list/test-list.component';
import { NotificationBarModule } from './thirdParty/ngx-notification-bar/notification-bar.module';
import { DisableControlDirective } from './UserCabinet/account-profile/disable-control.directive';
import { StripeCheckoutComponent } from './MainPage/stripe-checkout/stripe-checkout.component';
import { SavedCounterComponent } from './MainPage/saved-counter/seved-counter.component';
import { GoogleReviewsComponent } from './MainPage/google-reviews/google-reviews.component';
import {GoogleMapsModule} from "@angular/google-maps";
import {SharedModule} from "./module/shared/shared.module";

@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    HeaderComponent,
    NavigationComponent,
    FooterComponent,
    PanelsComponent,
    TestsComponent,
    TestCentersComponent,
    MainComponent,
    TestFormatPipe,
    NumbersOnlyDirective,
    TestListComponent,
    SavedCounterComponent,
    GoogleReviewsComponent,
    // CardComponent,
    AutocompleteComponent,
    CheckoutComponent,
    DynamicRouterPipe,
    DynamicContentComponent,
    SearchPipe,
    DisableControlDirective,
    StripeCheckoutComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    NgIdleKeepaliveModule.forRoot(),
    GoogleMapsModule,
    AutocompleteLibModule,
    ModalModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    MatTableModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatInputModule,
    MaterialModule,
    MatFormFieldModule,
    NgbModule,
    SharedModule,
    NgScrollbarModule,
    NgSelectModule,
    NotificationBarModule],
  exports: [
    DynamicContentComponent
  ],
  providers: [
    provideNgxWebstorage(
      withNgxWebstorageConfig({separator: ':', caseSensitive: true}),
      withLocalStorage(),
      withSessionStorage()
    ),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {appearance: 'fill'}
    },
    CookieService,
    DataService,
    SearchPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: ConfigInit,
    //   multi: true,
    //   deps: [Router,HttpClient, SessionInfoStorageService, AccountService]
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorIntercept,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule {
  constructor() {
    console.log('environment:', environment);
  }
}
